import React from "react";
import { CircularProgress } from "material-ui/Progress";

export default class LoadingCircle extends React.Component {

  render() {
    const {
      classes,
      type, 
      color
    } = this.props;
    if (type === "empty")
      return (
        <CircularProgress size={16} />
      )
    if (type === "root")
      return (
        <CircularProgress size={16} className={classes.root} />
      )
    if (type === "buttonProgress")
      return (
        <CircularProgress size={16} className={classes.buttonProgress}/>
      )
    if (type === "buttonProgressInside")
      return (
        <CircularProgress size={16} className={classes.buttonProgress} color={color}/>
      )
  }
}



// WEBPACK FOOTER //
// ./src/components/commons/LoadingCircle.js